import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { Avatar, Box, Tooltip, Typography } from '@mui/material';

/**
 * Props for the IconRow component.
 */
interface IconRowProps {
  /** A unique base identifier for accessibility and testing purposes */
  baseId: string;

  /** The primary content or data to display alongside the Avatar */
  content: string;

  /** The icon to display inside the Avatar */
  icon: JSX.Element;

  /** The background color for the Avatar */
  color: string;

  /** A subtitle providing additional context or information */
  subtitle: string;
}

/**
 * IconRow component displays an avatar with an icon, primary content, and a tooltip with a subtitle.
 */
const IconRow = (props: IconRowProps) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    marginY="12px"
  >
    <Box display="flex" alignItems="center">
      {/* Avatar Display */}
      <Avatar
        sx={{
          width: '50px',
          height: '50px',
          bgcolor: props.color,
          color: 'white',
          boxShadow: `${props.color}40 0px 1px 4px, ${props.color}59 0px 3px 12px 2px`, // Shadow with varying opacity
        }}
      >
        {props.icon}
      </Avatar>

      {/* Primary Content Display */}
      <Typography
        id={`${props.baseId}-info-block-data`} // Unique ID for accessibility/testing
        sx={{
          marginLeft: '16px',
          fontWeight: 500,
          fontSize: '25px',
        }}
      >
        {props.content}
      </Typography>
    </Box>

    <Tooltip title={props.subtitle} arrow>
      <HelpOutlineRoundedIcon
        sx={{
          cursor: 'help',
        }}
      />
    </Tooltip>
  </Box>
);

export default IconRow;
